import { useEffect } from 'react';
import { finishSignupFlow } from '../stores/signup-flow-store';

/** For a page that ends signup: the answers kept for this tab are cleared once it shows. */
export function useFinishSignupFlow(): void {
  useEffect(() => {
    finishSignupFlow();
  }, []);
}
